export default __webpack_public_path__ + "static/media/fig-14-powerhouse-cavern.0940b2d4.png";